import { getRequest } from '../api-handler';
import { RecipientDetailDto } from './recipient';

export const RecipientApi = {
  getById: (id: number) => getRequest<RecipientDetailDto>(`/recipients/${id}`)
};
